import { Container, Section } from '@repo/ui'
import { Button } from '@repo/ui/components/ui/button'
import { Link } from '@tanstack/react-router'
import { PostContent } from '../components/post/content'
import { PostCTA } from '../components/post/cta'
import { PostFooter } from '../components/post/footer'
import { PostHeader } from '../components/post/header'
import { getBlogPost } from '../data'

interface BlogPostPageProps {
  slug: string
}

export function BlogPostPage({ slug }: BlogPostPageProps) {
  const post = getBlogPost(slug)

  if (!post) {
    return (
      <Section variant="default">
        <Container size="prose" className="text-center">
          <h1 className="mb-4 text-4xl font-bold">Post Not Found</h1>
          <p className="mb-8 text-muted-foreground">
            The blog post you're looking for doesn't exist.
          </p>
          <Button asChild>
            <Link to="/blog">← Back to Blog</Link>
          </Button>
        </Container>
      </Section>
    )
  }

  return (
    <Section variant="default">
      <article>
        <Container size="prose">
          <PostHeader post={post} />
          <PostContent content={post.content} />
          <PostFooter />
          <PostCTA />
        </Container>
      </article>
    </Section>
  )
}
